import { Skeleton } from "@/components/ui/skeleton";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from "@/components/ui/table";

export const LeadsTableSkeleton = () => (
  <Table>
    <TableHeader>
      <TableRow className="border-white/5 hover:bg-transparent">
        <TableHead className="w-10 pl-4" />
        <TableHead className="text-xs font-bold tracking-widest uppercase">Company</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase">Contact</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase">Service</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase">Source</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase">Stage</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase text-right">Score</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase text-right">Value</TableHead>
        <TableHead className="text-xs font-bold tracking-widest uppercase text-right">Actions</TableHead>
      </TableRow>
    </TableHeader>
    <TableBody>
      {Array.from({ length: 8 }).map((_, i) => (
        <TableRow key={i} className="border-white/5">
          <TableCell className="pl-4"><Skeleton className="h-4 w-4" /></TableCell>
          <TableCell>
            <div className="flex items-center gap-2">
              <Skeleton className="h-7 w-7 rounded-sm flex-shrink-0" />
              <Skeleton className="h-4 w-32" />
            </div>
          </TableCell>
          <TableCell><Skeleton className="h-4 w-24" /></TableCell>
          <TableCell><Skeleton className="h-4 w-28" /></TableCell>
          <TableCell><Skeleton className="h-4 w-20" /></TableCell>
          <TableCell><Skeleton className="h-5 w-16 rounded-sm" /></TableCell>
          <TableCell className="text-right"><Skeleton className="h-5 w-8 ml-auto rounded-sm" /></TableCell>
          <TableCell className="text-right"><Skeleton className="h-4 w-14 ml-auto" /></TableCell>
          <TableCell className="text-right"><Skeleton className="h-8 w-8 ml-auto rounded-sm" /></TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);
